import HeroSection from "../HeroSection/HeroSection"
import ImageTextSection from "../ImageTextSection/ImageTextSection"
import style from "./LandingPage.module.scss"
import mediaContents from "./MediaContentStore"
import imageTextStyle from "../ImageTextSection/ImageTextSection.module.scss"
import { AmazonLogo } from "@web/components/SVG/AmazonLogo"
import { Stage4SolutionsLogo } from "@web/components/SVG/Stage4SolutionsLogo"
import { OpenAiLogo } from "@web/components/SVG/OpenAiLogo"
import { BecuLogo } from "@web/components/SVG/BecuLogo"
import { IntelliProLogo } from "@web/components/SVG/IntelliProLogo"
import { UsTechSolutionsLogo } from "@web/components/SVG/UsTechSolutionsLogo"
import { SquarespaceLogo } from "@web/components/SVG/SquarespaceLogo"
import { LanceSoftLogo } from "@web/components/SVG/LanceSoftLogo"
import { EventbriteLogo } from "@web/components/SVG/EventbriteLogo"
import { StarbucksLogo } from "@web/components/SVG/StarbucksLogo"
import { SoftPathLogo } from "@web/components/SVG/SoftPathLogo"
import { AwsLogo } from "@web/components/SVG/AwsLogo"

const LOGOS = [
  [AwsLogo, "tmb-w-28"],
  [BecuLogo, "tmb-w-40 lg:tmb-w-56 tmb-mb-1"],
  [SquarespaceLogo, "tmb-w-64 lg:tmb-w-72"],
  [UsTechSolutionsLogo, "tmb-w-40 lg:tmb-w-56"],
  // [OpenAiLogo, "tmb-w-40 lg:tmb-w-56 tmb-mb-1"], // drop temporarily
  [LanceSoftLogo, "tmb-w-56 lg:tmb-w-64"],
  [AmazonLogo, "tmb-w-32 lg:tmb-w-44"],
  [Stage4SolutionsLogo, "tmb-w-40 lg:tmb-w-56 tmb-mb-2"],
  [StarbucksLogo, "tmb-w-18 lg:tmb-w-24 tmb-mb-2"],
  [SoftPathLogo, "tmb-w-64 lg:tmb-w-72 tmb-mb-2"],
  [EventbriteLogo, "tmb-w-56 lg:tmb-w-64 tmb-mb-1"],
  [IntelliProLogo, "tmb-w-40 lg:tmb-w-56 tmb-mb-2"],
] as const

function LandingPage() {
  return (
    <div className={style.landingPage}>
      <HeroSection />

      <div className="tmb-mb-24 tmb-overflow-hidden">
        <h2 className="tmb-text-center">Used By The Most Innovative Recruiters At</h2>

        <div className={style.carouselContainer}>
          <div className={style.carousel}>
            {LOGOS.concat(LOGOS).map(([Logo, className], i) => (
              <Logo key={i} className={className} />
            ))}
          </div>
        </div>
      </div>

      <ImageTextSection
        className={imageTextStyle.reverse}
        textClassName={imageTextStyle.textContainer}
        mediaContent={mediaContents[0]!.media}
        title={mediaContents[0]!.title}
        content={mediaContents[0]!.content}
      />
      <ImageTextSection
        textClassName={imageTextStyle.textContainer}
        mediaContent={mediaContents[1]!.media}
        title={mediaContents[1]!.title}
        content={mediaContents[1]!.content}
      />
      <ImageTextSection
        className={imageTextStyle.reverse}
        textClassName={imageTextStyle.textContainer}
        mediaContent={mediaContents[2]!.media}
        title={mediaContents[2]!.title}
        content={mediaContents[2]!.content}
      />
      <ImageTextSection
        className={imageTextStyle.textContainer}
        textClassName={imageTextStyle.textContainer}
        mediaContent={mediaContents[3]!.media}
        title={mediaContents[3]!.title}
        content={mediaContents[3]!.content}
      />
    </div>
  )
}

export default LandingPage
